import { gql } from "@apollo/client";

export const GET_GROWTH_REPORTS = gql`
  query GetGrowthReports($data: GrowthReportsInput!) {
    getGrowthReports(data: $data) {
      status
      message
      referrals {
        total
        converted
        conversionRate
        rewardsPaid
        byStatus {
          status
          count
        }
        daily {
          date
          count
        }
        topReferrers {
          userId
          name
          phone
          referrals
          converted
        }
      }
      coupons {
        totalDiscount
        ordersWithCoupon
        avgDiscount
        byCoupon {
          code
          uses
          users
          discount
        }
      }
      wallet {
        rows {
          category
          type
          count
          amount
        }
      }
    }
  }
`;
